'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useAdmin } from '@paeffgen/react/crm-documents/feature-auth';

/**
 * Hängt den Admin-Cross-Login-Kontext als Sentry-Tags an — zusätzlich zur
 * Identität aus SentryUserSync (die immer der echte eingeloggte Admin bleibt).
 *
 * Trennung Identität vs. Kontext:
 *  - user (SentryUserSync)        = wer agiert (Admin, Rückfrage-Adresse)
 *  - crm.viewedCustomers (hier)   = welche Debitoren gerade betrachtet werden
 *
 * Die Tags gelten für alle Error-Events UND das "Fehler melden"-Feedback und
 * sind in Sentry filterbar ("alle Fehler beim Betrachten von Debitor X").
 *
 * Muss innerhalb des AdminProvider liegen (useAdmin), rendert nichts.
 */
export function SentryCrossLoginSync(): null {
  const { isCrossLogin, selectedCustomerNumbers } = useAdmin();

  useEffect(() => {
    Sentry.setTag('crm.crossLogin', isCrossLogin);
    Sentry.setTag(
      'crm.viewedCustomers',
      isCrossLogin && selectedCustomerNumbers.length > 0
        ? selectedCustomerNumbers.join(',')
        : undefined,
    );
  }, [isCrossLogin, selectedCustomerNumbers]);

  return null;
}
